import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Set initial isMobile state after the first render
    setIsMobile(window.innerWidth < 768);

    // Resize listener to update isMobile on window resize
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile && isOpen) {
        setIsOpen(false);
        document.body.style.overflow = 'auto';
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? 'hidden' : 'auto';
  };

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setActiveLink(id);
    if (isMobile) {
      setIsOpen(false);
      document.body.style.overflow = 'auto';
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const nav = document.querySelector('.navbar');
      const hamburger = document.querySelector('.hamburger');
      if (isOpen && nav && hamburger && !nav.contains(event.target) && !hamburger.contains(event.target)) {
        setIsOpen(false);
        document.body.style.overflow = 'auto';
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]);

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setActiveLink(null);
    if (isMobile && isOpen) {
      setIsOpen(false);
      document.body.style.overflow = 'auto';
    }
  };

  const navItems = [
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'experience', label: 'Experience' },
     { id: 'team', label: 'Feedback' },
    { id: 'contact', label: 'Contact' },
  ];

  const mobileMenuStyles = {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: 0,
    right: 0,
    height: '100vh',
    width: 'min(75%, 320px)',
    backgroundColor: 'rgba(25, 25, 35, 0.98)',
    paddingTop: '6rem',
    paddingLeft: '2rem',
    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
    transition: 'transform 0.3s ease-out',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    boxShadow: '-5px 0 15px rgba(0,0,0,0.2)',
    zIndex: 1500, // Increased zIndex for hamburger clickability
    overflowY: 'auto',
  };

  const desktopMenuStyles = {
    display: 'flex',
    listStyle: 'none',
    gap: 'clamp(0.5rem, 2vw, 1.5rem)',
    margin: 0,
    padding: 0,
  };

  const linkStyles = {
    cursor: 'pointer',
    padding: 'clamp(0.3rem, 1vw, 0.5rem) clamp(0.5rem, 1.5vw, 1rem)',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    position: 'relative',
    fontSize: 'clamp(0.9rem, 3vw, 1.1rem)',
    fontWeight: '500',
    color: 'white',
  };

  return (
    <>
      <nav
        className="navbar"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1rem 5%',
          backgroundColor: 'linear-gradient(135deg,rgba(5, 4, 7, 0),rgb(0, 0, 0),rgb(11, 6, 20))',
          color: 'white',
          position: 'fixed',
          width: '90%',
          top: 0,
          zIndex: 1000,
          boxShadow: scrolled ? '0 4px 12px rgba(250, 248, 249, 0.15)' : 'none',
          transition: 'all 0.3s ease',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(1.3rem, 5vw, 1.8rem)',
            cursor: 'pointer',
            margin: 0,
            fontWeight: '700',
            background: 'linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            letterSpacing: '1px',
            transition: 'transform 0.2s ease',
          }}
          onClick={handleLogoClick}
          onTouchStart={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
          onTouchEnd={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          Abhay's Portfolio
        </h1>

        {/* Hamburger Menu */}
        <div
          className="hamburger"
          style={{
            display: isMobile ? 'flex' : 'none',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '30px',
            height: '21px',
            cursor: 'pointer',
            zIndex: 1500, // Increased zIndex for visibility
          }}
          onClick={toggleMenu}
        >
          <div
            style={{
              width: '100%',
              height: '3px',
              backgroundColor: isOpen ? '#6a11cb' : 'white',
              borderRadius: '10px',
              transform: isOpen ? 'rotate(45deg) translate(5px, 6px)' : 'none',
              transition: 'all 0.3s ease',
            }}
          ></div>
          <div
            style={{
              width: '100%',
              height: '3px',
              backgroundColor: isOpen ? 'transparent' : 'white',
              borderRadius: '10px',
              opacity: isOpen ? 0 : 1,
              transition: 'all 0.3s ease',
            }}
          ></div>
          <div
            style={{
              width: '100%',
              height: '3px',
              backgroundColor: isOpen ? '#6a11cb' : 'white',
              borderRadius: '10px',
              transform: isOpen ? 'rotate(-45deg) translate(5px, -6px)' : 'none',
              transition: 'all 0.3s ease',
            }}
          ></div>
        </div>

        {/* Desktop Navigation Links */}
        {!isMobile && (
          <ul style={desktopMenuStyles}>
            {navItems.map((item) => (
              <li
                key={item.id}
                style={{
                  ...linkStyles,
                  color: activeLink === item.id ? '#6a11cb' : 'white',
                }}
                onClick={() => handleScroll(item.id)}
              >
                {item.label}
              </li>
            ))}
          </ul>
        )}
      </nav>

      {/* Mobile Navigation Links */}
      {isMobile && (
        <ul style={mobileMenuStyles}>
          {navItems.map((item) => (
            <li
              key={item.id}
              style={{
                ...linkStyles,
                padding: '1.2rem 0',
                fontSize: '1.2rem',
                color: activeLink === item.id ? '#6a11cb' : 'white',
              }}
              onClick={() => handleScroll(item.id)}
              onTouchStart={(e) => {
                e.currentTarget.style.transform = 'scale(0.95)';
                e.currentTarget.style.backgroundColor = 'rgba(106, 17, 203, 0.1)';
              }}
              onTouchEnd={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}

      {/* Overlay for mobile menu */}
      {isMobile && isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 900,
            transition: 'opacity 0.3s ease',
          }}
          onClick={() => {
            setIsOpen(false);
            document.body.style.overflow = 'auto';
          }}
        />
      )}
    </>
  );
};

export default Navbar;
